import React, { useState, useEffect } from "react";
import Szczalka from "../img/szczalka.svg";

const Calculator = () => {
  const [value, setValue] = useState("0");
  const [screen, setScreen] = useState("0");
  const [memory, setMemory] = useState(null);
  const [operation, setOperation] = useState(null);
  const [change, setChange] = useState(0);

  useEffect(() => {
    const intervalTwo = setInterval(() => {
      setChange((prevState) => prevState + 1);
    }, 5);
    if (change === 100) {
      return () => {
        clearInterval(intervalTwo);
      };
    }
  }, []);

  console.log("Operation:", operation);
  console.log("Value:", value);
  console.log("Screen:", screen);

  const handleNumber = (content) => {
    const num = parseFloat(value);

    if (content === "C") {
      setValue("0");
      setScreen("0");
      setMemory(null);
      setOperation(null);
      return;
    }

    if (content === "±") {
      setValue((num * -1).toString());
      setScreen((num * -1).toString());
      return;
    }

    if (content === "%") {
      setValue((num / 100).toString());
      setScreen((num / 100).toString());
      setMemory(null);
      setOperation(null);
      return;
    }

    if (content === "+") {
      if (operation !== null) {
        if (operation === "+" || value !== "0") {
          setMemory((prevState) => prevState + parseFloat(value));
          setScreen("+");
        }
      } else {
        setMemory(parseFloat(value));
        setScreen("0");
      }
      setOperation("+");
      setValue((prevState) => "0");
      setScreen(() => (value === "0" ? "0" : "+"));
      return;
    }

    if (content === "b") {
      if (operation !== null) {
        if (operation === "b" || value !== "0") {
          setValue((prevState) => prevState.slice(0, -1));
          setScreen((prevState) => prevState.slice(0, -1));
        }
      }
      setOperation("b");

      return;
    }

    if (content === "×") {
      if (operation !== null) {
        if (operation === "×") {
          setMemory((prevState) => prevState + parseFloat(value));
          setScreen("×");
        }
      } else {
        setMemory(parseFloat(value));
        setScreen(value);
      }
      setOperation("×");
      setValue((prevState) => "0");
      setScreen("×");
      return;
    }

    if (content === "−") {
      if (operation !== null) {
        if (operation === "−") {
          setMemory((prevState) => prevState + parseFloat(value));
          setScreen("−");
        }
      } else {
        setMemory(parseFloat(value));
        setScreen(value);
      }
      setOperation("−");
      setValue(() => "0");
      setScreen("−");
      return;
    }

    if (content === "÷") {
      if (operation !== null) {
        if (operation === "÷") {
          setMemory((prevState) => prevState / parseFloat(value));
          setScreen("÷");
        }
      } else {
        setMemory(parseFloat(value));
        setScreen("0");
      }
      setOperation("÷");
      setValue((prevState) => "0");
      setScreen(() => (value === "0" ? "0" : "÷"));
      return;
    }

    if (content === "=") {
      if (!operation) return;
      if (operation === "+") {
        setValue((memory + parseFloat(value)).toString());
        setScreen((memory + parseFloat(value)).toString());
      } else if (operation === "−") {
        setValue((memory - parseFloat(value)).toString());
        setScreen((memory - parseFloat(value)).toString());
      } else if (operation === "×") {
        setValue((memory * parseFloat(value)).toString());
        setScreen((memory * parseFloat(value)).toString());
      } else if (operation === "÷") {
        setValue((memory / parseFloat(value)).toString());
        setScreen((memory / parseFloat(value)).toString());
      }

      setMemory(parseFloat(value));
      setMemory(null);
      setOperation(null);
      return;
    }

    if (content === ".") {
      if (value.includes(".")) return;
      setValue((prevState) => prevState + ".");
      setScreen((value + ".").toString());
      return;
    }

    if (value.length - 1 === ".") {
      setValue(((prevState) => prevState + content).toString());
    } else {
      setValue(parseFloat(value + content).toString());
      setScreen(parseFloat(value + content).toString());
    }
  };
  return (
    <>
      <div className="calculator_container" style={{ opacity: change / 100 }}>
        <div className="screen">{screen.substring(0, 13)}</div>
        <div className="keys_container">
          <div className="keys_row">
            <button
              onClick={(content) => handleNumber("C")}
              className="key special"
              content="C"
            >
              C
            </button>
            <button
              onClick={(content) => handleNumber("±")}
              className="key special"
              content="±"
            >
              +/-
            </button>
            <button
              onClick={(content) => handleNumber("%")}
              className="key special"
              content="%"
            >
              %
            </button>
            <button
              onClick={(content) => handleNumber("÷")}
              className="key function"
              content="÷"
            >
              ÷
            </button>
          </div>
          <div className="keys_row">
            <button
              onClick={(content) => handleNumber("1")}
              className="key normal"
              content="1"
            >
              1
            </button>
            <div
              onClick={(content) => handleNumber("2")}
              className="key normal"
              content="2"
            >
              2
            </div>
            <div
              onClick={(content) => handleNumber("3")}
              className="key normal"
              content="3"
            >
              3
            </div>
            <div
              onClick={(content) => handleNumber("×")}
              className="key function"
              content="×"
            >
              ×
            </div>
          </div>
          <div className="keys_row">
            <div
              onClick={(content) => handleNumber("4")}
              className="key normal"
              content="4"
            >
              4
            </div>
            <div
              onClick={(content) => handleNumber("5")}
              className="key normal"
              content="5"
            >
              5
            </div>
            <div
              onClick={(content) => handleNumber("6")}
              className="key normal"
              content="6"
            >
              6
            </div>
            <div
              onClick={(content) => handleNumber("−")}
              className="key function"
              content="−"
            >
              −
            </div>
          </div>
          <div className="keys_row">
            <div
              onClick={(content) => handleNumber("7")}
              className="key normal"
              content="7"
            >
              7
            </div>
            <div
              onClick={(content) => handleNumber("8")}
              className="key normal"
              content="8"
            >
              8
            </div>
            <div
              onClick={(content) => handleNumber("9")}
              className="key normal"
              content="9"
            >
              9
            </div>
            <div
              onClick={(content) => handleNumber("+")}
              className="key function"
              content="+"
            >
              +
            </div>
          </div>
          <div className="keys_row">
            <div
              onClick={(content) => handleNumber("b")}
              style={{ backgroundImage: `url(${Szczalka})` }}
              className="key special"
              content="b"
            ></div>
            <div
              onClick={(content) => handleNumber("0")}
              className="key normal"
              content="0"
            >
              0
            </div>
            <div
              onClick={(content) => handleNumber(".")}
              className="key special"
              content="."
            >
              .
            </div>
            <div
              onClick={(content) => handleNumber("=")}
              className="key function"
              content="="
            >
              =
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calculator;
